import EditableMuiDatePicker from 'Global/Components/EditableComponents/EditableMuiDatePicker/EditableMuiDatePicker';
import EditablePersianSupportTextField from 'Global/Components/EditableComponents/EditablePersianSupportTextField';
import PersianSupportNumericTextField from 'Global/Components/UnEditableComponents/PersianSupportNumericTextField/PersianSupportNumericTextField';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import i18next from 'i18next';
import React from 'react';
import { GetCurrentDateInJalai } from 'utils/GetCurrentDateInJalai';

const useUploaderFormDataArray = (
  price,
  tracing_id,
  details,
  base64
) => {
  const isEnglish = i18next.language === 'en';

  const fileName = FindLangKey(
    'general-public-label-file-name'
  );
  const fileDate = FindLangKey(
    'general-public-label-file-date'
  );
  const fileDescription = FindLangKey(
    'general-public-label-file-description'
  );

  const renew_contract_label = FindLangKey(
    'freeze-contracts-label-charge-contract'
  );

  return [
    {
      element: (
        <EditablePersianSupportTextField
          isEnglish={isEnglish}
          label={fileName}
          Initialvalue={base64?.fileName || ''}
          disabled={true}
        />
      ),
      name: 'fileName',
    },
    {
      element: (
        <EditableMuiDatePicker
          Placeholder={fileDate}
          isEnglish={isEnglish}
          disableInit={true}
          initialValue={
            base64?.fileDate || GetCurrentDateInJalai()
          }
        />
      ),
      name: 'fileDate',
    },
    {
      element: (
        <EditablePersianSupportTextField
          label={fileDescription}
          Initialvalue={renew_contract_label}
        />
      ),
      name: 'fileDescription',
    },

    {
      element: (
        <PersianSupportNumericTextField
          label={price}
          thousandSeparator={true}
          isOctalAllowed={false}
        />
      ),
      name: 'mablagh',
      required: true,
    },
    {
      element: (
        <PersianSupportNumericTextField
          label={tracing_id}
          isOctalAllowed={true}
        />
      ),
      name: 'ShomarePaigiri',
      required: true,
    },
  ];
};

export default useUploaderFormDataArray;
